import { Card, Col, Radio, Row, Typography, Select } from 'antd';
import React, { useState, useEffect } from 'react';
import { Navigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import PageTitle from "../page-header/PageHeader";
import { getDefaultValidity, fetchValidityEntry } from '../../redux/rtk/features/leavePolicy/leavePolicySlice';
import getUserFromToken from '../../utils/getUserFromToken';

import AddLeave from "./AddLeave";
import AddToil from './AddToil';
import GetToil from './getToil';
import LeaveAllocation from './leaveAllocation';

const { Text } = Typography;

const Leave = (props) => {
  const isLogged = Boolean(localStorage.getItem("isLogged"));
  const loggedInUserId = getUserFromToken();
  const [formType, setFormType] = useState('Leave');
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedValidityId, setSelectedValidityId] = useState(null);
  const [selectedToilUserId, setSelectedToilUserId] = useState();
  const dispatch = useDispatch();
  
  // Get validity data from Redux store
  const { defaultValidity, validity, loading: validityLoading } = useSelector((state) => state.leavePolicy);

  // Fetch validity entries and default validity on component mount
  useEffect(() => {
    dispatch(fetchValidityEntry());
    dispatch(getDefaultValidity());
  }, [dispatch]);

  // Set default validity when data is loaded
  useEffect(() => {
    if (defaultValidity && defaultValidity.length > 0) {
      setSelectedValidityId(defaultValidity[0]?.validity_id);
    }
  }, [defaultValidity]);

  // Don't initialize selectedToilUserId - let GetToil use logged-in user as default
  // selectedToilUserId will only be set when user selects someone from dropdown in AddToil

  if (!isLogged) {
    return <Navigate to={"/admin/auth/login"} replace={true} />;
  }
  
  const handleUserChange = (userId) => {
    setSelectedUserId(userId);
  };

  const handleValidityChange = (validityId) => {
    setSelectedValidityId(validityId);
  };

  // Filter validity data to show only entries where applyFor is true
  const filteredValidity = validity ? validity.filter(item => item.applyFor === true) : [];
  const selectedValidity = filteredValidity.find((item) => item.id === selectedValidityId);

  return (
    <>
      <PageTitle title='Back' />
      <Row gutter={16}>
        <Col span={24} style={{ padding: 10 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <Radio.Group onChange={(e) => setFormType(e.target.value)} value={formType}>
              <Radio.Button value="Leave">Leave</Radio.Button>
              <Radio.Button value="Toil">Toil</Radio.Button>
            </Radio.Group>
            <Select
              placeholder="Select Validity Policy"
              value={selectedValidityId}
              onChange={handleValidityChange}
              style={{ width: '25%' }}
              loading={validityLoading}
            >
              {filteredValidity && filteredValidity.length > 0 ? (
                filteredValidity.map((validityItem) => (
                  <Select.Option key={validityItem.id} value={validityItem.id}>
                    {validityItem.name}
                  </Select.Option>
                ))
              ) : (
                <Select.Option disabled>No validity policies available</Select.Option>
              )}
            </Select>
          </div>
        </Col>
        {formType === 'Leave' ? (
          <>
            <Col span={8}>
              <Card title="Application for Leave">
                <AddLeave 
                  onUserChange={handleUserChange}
                  validityId={selectedValidityId}
                  validFrom={selectedValidity?.validFrom}
                  validTo={selectedValidity?.validTo}
                />
              </Card>
            </Col>
            <Col span={16}>
              <Card title="Leave Allocation">
                <LeaveAllocation 
                  userId={selectedUserId}
                  validityId={selectedValidityId}
                />
              </Card>
            </Col>
          </>
        ) : (
          <>
          <Col span={8}>
            <Card title="Application for Toil">
              <AddToil 
                validityId={selectedValidityId}
                onUserSelected={(userId) => {
                  console.log("Leave.js - onUserSelected called with userId:", userId);
                  setSelectedToilUserId(userId);
                }}
                onToilAdded={(userId) => {
                  console.log("Leave.js - onToilAdded called with userId:", userId);
                  setSelectedToilUserId(userId);
                }}
              />
            </Card>
          </Col>
          <Col span={16}>
          <Card title="Toil">
            <GetToil 
              validityId={selectedValidityId}
              userId={selectedToilUserId}
            />
          </Card>
        </Col>
        </>
        )}
      </Row>
    </>
  );
};

export default Leave;
